import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { gql } from "@apollo/client";
import { DateTime } from "luxon";
import { formattedPrice, Button, ButtonVariant, activeFulfillmentIdVar, benefitFulfillmentText } from "@withfriendsco/wf-components";
gql `
  fragment MembershipFulfillmentAddon on Addon {
    id
    description
    additionalCost {
      amount
    }
  }

  fragment MembershipFulfillment on Fulfillment {
    id
    fulfillmentDate
    isFulfilled
    productSelections {
      ...ChooseProductSelection
    }
    variant {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
    }
    addons {
      ...MembershipFulfillmentAddon
    }
    benefit {
      id
      name
      ... on SubscriptionBenefit {
        shippingIncluded
        deliveredToYour
      }
      variants {
        id
      }
      products {
        id
        variants {
          id
        }
      }
    }
    address {
      shippingName
      line1
      line2
      city
      state
      zip
      country
    }
    trackingUrl
    shippingNotes
  }
`;
const MembershipFulfillment = ({ fulfillment, retailDiscount, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const dateTime = DateTime.fromSQL(fulfillment.fulfillmentDate);
    const discountMultiplier = (100 - retailDiscount) * 0.01;
    const missingOptions = (!fulfillment.variant && ((_a = fulfillment.benefit.variants) === null || _a === void 0 ? void 0 : _a.length)) || (((_b = fulfillment.productSelections) === null || _b === void 0 ? void 0 : _b.filter(selection => { var _a; return (_a = selection.variant) === null || _a === void 0 ? void 0 : _a.id; }).length) < fulfillment.benefit.products.filter(product => { var _a; return !!((_a = product.variants) === null || _a === void 0 ? void 0 : _a.length); }).length);
    const missingAddress = !(!!fulfillment.address.line1 && !!fulfillment.address.city && !!fulfillment.address.state && !!fulfillment.address.zip && !!fulfillment.address.country);
    let missingSteps = [];
    if (missingOptions)
        missingSteps.push("select an option");
    if (missingAddress)
        missingSteps.push("enter your address");
    return (_jsxs("div", { className: "border-2 shadow-md border-black p-4 " + (!fulfillment.isFulfilled ? "m-4" : "my-4"), children: [_jsxs("h4", { children: [((_c = fulfillment.benefit) === null || _c === void 0 ? void 0 : _c.__typename) == 'WelcomeGiftBenefit' ? "Welcome Gift" : "Subscription Box", ": ", fulfillment.benefit.name] }), _jsxs("div", { className: "border-t border-wfGray-300 mt-4 pt-4", children: [benefitFulfillmentText(fulfillment.benefit)('fulfillment_date'), ": ", dateTime.toLocaleString()] }), !fulfillment.isFulfilled ? (_jsx("div", { style: { "marginBottom": "13px" }, children: _jsx("a", { target: "_blank", className: "text-wfGray-700 underline hover:text-wfGray-500", href: "https://help.withfriends.co/5364861-tracking-my-subscription-box", children: "Read about fulfillment dates" }) })) : (fulfillment.trackingUrl ? (_jsx("div", { style: { "marginBottom": "13px" }, children: _jsx("a", { target: "_blank", className: "text-wfGray-700 underline hover:text-wfGray-500", href: fulfillment.trackingUrl, children: "Track your shipment" }) }))
                : null), (!!((_d = fulfillment.variant) === null || _d === void 0 ? void 0 : _d.description) || ((_e = fulfillment.productSelections) === null || _e === void 0 ? void 0 : _e.some(productSelection => { var _a; return (_a = productSelection.variant) === null || _a === void 0 ? void 0 : _a.description; }))) && (_jsxs("div", { children: [!fulfillment.isFulfilled && "Current options selected: ", " ", fulfillment.productSelections
                        .filter(productSelection => !!productSelection.variant)
                        .map(productSelection => productSelection.variant.description)
                        .concat(fulfillment.variant ? [fulfillment.variant.description] : [])
                        .join(", ")] })), ((_f = fulfillment.addons) === null || _f === void 0 ? void 0 : _f.length) ? (_jsx("h4", { className: "border-t border-wfGray-300 mt-4 pt-4", children: "Addons Selected" })) : null, _jsx("ul", { children: (_g = fulfillment.addons) === null || _g === void 0 ? void 0 : _g.map((a) => {
                    return (_jsxs("li", { children: [a.description, ":", " ", _jsxs("span", { children: ["\u00A0", discountMultiplier == 1 ? (_jsx("span", { children: formattedPrice(a.additionalCost.amount) })) : (_jsxs(React.Fragment, { children: [_jsx("span", { className: "line-through", style: { textDecoration: "line-through" }, children: formattedPrice(a.additionalCost.amount) }), _jsxs("span", { className: "font-heavy", children: [" ", formattedPrice(a.additionalCost.amount * discountMultiplier)] })] }))] })] }, a.id));
                }) }), !missingAddress ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "font-bold mt-4 pt-4 border-t border-wfGray-300" }), _jsxs("div", { children: [((_h = fulfillment.address.shippingName) === null || _h === void 0 ? void 0 : _h.length) ? (_jsxs(_Fragment, { children: [fulfillment.address.shippingName, _jsx("br", {})] })) : null, fulfillment.address.line1, _jsx("br", {}), ((_j = fulfillment.address.line2) === null || _j === void 0 ? void 0 : _j.length) ? (_jsxs(_Fragment, { children: [fulfillment.address.line2, _jsx("br", {})] })) : null, fulfillment.address.city, ", ", fulfillment.address.state, " ", fulfillment.address.zip, _jsx("br", {}), fulfillment.address.country, fulfillment.shippingNotes ? (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("br", {}), fulfillment.shippingNotes] })) : null] })] })) : "", !fulfillment.isFulfilled && (_jsxs("div", { className: "font-bold mt-4 pt-4 border-t border-wfGray-300 my-2", children: [missingSteps.length ? (_jsxs("div", { className: "font-bold text-lg text-wfRed-600", children: ["You need to ", missingSteps.join(" and "), " before this box can be shipped. Click the button below."] })) : "", (missingSteps.length || DateTime.fromSQL(fulfillment.fulfillmentDate) > DateTime.now().setZone('America/New_York')) ? (_jsx(Button, { className: "my-4", variant: ButtonVariant.Purple, onClick: () => {
                            window.parent.postMessage({ action: "scrollTo", value: 0 }, '*');
                            activeFulfillmentIdVar(fulfillment.id);
                        }, children: "Edit this shipment" })) : (_jsxs("div", { className: "text-wfGray-500 my-4", children: [_jsx(Button, { className: "opacity-50 cursor-not-allowed", variant: ButtonVariant.Purple, disabled: true, children: "Edit this shipment" }), _jsx("p", { className: "mt-2", children: "It's too late to edit this shipment" })] }))] }))] }));
};
export default MembershipFulfillment;
